import React from 'react';
import { Sun, Moon, MoonStars, Icon } from '@phosphor-icons/react';
import { useThemeStore, ThemeMode, THEME_MODES } from '../stores/themeStore';

const THEME_OPTIONS: Record<ThemeMode, { label: string; icon: Icon }> = {
    day: { label: 'Day', icon: Sun },
    night: { label: 'Night', icon: Moon },
    midnight: { label: 'Midnight', icon: MoonStars }
};

interface ThemeSwitcherProps {
    // compact: icon-only segments for menus; full: icon + label
    variant?: 'compact' | 'full';
    className?: string;
}

// Segmented Day | Night | Midnight control
export const ThemeSwitcher: React.FC<ThemeSwitcherProps> = ({ variant = 'full', className = '' }) => {
    const { theme, setTheme } = useThemeStore();

    return (
        <div role="radiogroup" aria-label="Appearance" className={`flex items-center gap-1 p-1 rounded-lg bg-zinc-900 border border-white/5 ${className}`}>
            {THEME_MODES.map((mode) => {
                const { label, icon: ModeIcon } = THEME_OPTIONS[mode];
                const isActive = theme === mode;
                return (
                    <button
                        key={mode}
                        type="button"
                        role="radio"
                        aria-checked={isActive}
                        title={`${label} Mode`}
                        onClick={() => setTheme(mode)}
                        className={`flex-1 flex items-center justify-center gap-1.5 rounded-md transition-colors ${variant === 'compact' ? 'py-1.5' : 'px-3 py-2'} text-xs font-medium ${isActive
                            ? 'bg-graphite text-white shadow-sm'
                            : 'text-zinc-500 hover:text-zinc-200 hover:bg-white/5'}`}
                    >
                        <ModeIcon className="w-3.5 h-3.5" weight={isActive ? 'fill' : 'regular'} />
                        {variant === 'full' && <span>{label}</span>}
                    </button>
                );
            })}
        </div>
    );
};
